const LOCALHOST = 'localhost';

const localConfig = {
    apiBasePath: 'https://dev-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice-dev/api',
    clientId: '10cb236a-805a-473f-bece-8ad4b3fad13e',
    redirectBaseUrl: 'http://localhost:3000',
    oidcConfigUrl: 'https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/ta-dev/',
    gsodBaseUrl: 'https://dev-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: 'OHI104776',
    trOhid2025: 'OHI104777',
    CRH_2025_OHI_IDS: ['OHI102753'],
    Bradesco2025: ['OHI105056'],
};

const devConfig = {
    apiBasePath: 'https://dev-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice-dev/api',
    clientId: '10cb236a-805a-473f-bece-8ad4b3fad13e',
    redirectBaseUrl: 'https://dev-analytics.orglabsolutions.com',
    oidcConfigUrl: 'https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/ta-dev/',
    gsodBaseUrl: 'https://dev-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: 'OHI104776',
    trOhid2025: 'OHI104777',
    CRH_2025_OHI_IDS: ['OHI102753'],
    Bradesco2025: ['OHI105056'],
};

const stgConfig = {
    apiBasePath: 'https://stg-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice-stg/api',
    clientId: 'ba3ce4c6-9199-4eab-b6c6-9bd7ac833242',
    redirectBaseUrl: 'https://stg-analytics.orglabsolutions.com',
    oidcConfigUrl: 'https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/ta-dev/',
    gsodBaseUrl: 'https://stg-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: 'OHI104776',
    trOhid2025: 'OHI104777',
    CRH_2025_OHI_IDS: ['OHI15415'],
    Bradesco2025: ['OHI104170'],
};

const prodUsConfig = {
    apiBasePath: 'https://us-ohi-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice/api',
    clientId: '98bd5004-43eb-450b-8426-349a5d22cd69',
    redirectBaseUrl: 'https://us-ohi-analytics.orglabsolutions.com',
    oidcConfigUrl: 'https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/textanalytics/',
    gsodBaseUrl: 'https://us-ohi-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: '',
    trOhid2025: '',
    CRH_2025_OHI_IDS: [],
    Bradesco2025: [],
};

const prodUkConfig = {
    apiBasePath: 'https://ohi-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice/api',
    clientId: '0edfd9b0-83b0-4055-965f-832f9d2ad779',
    redirectBaseUrl: 'https://ohi-analytics.orglabsolutions.com',
    oidcConfigUrl: 'https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/textanalytics/',
    gsodBaseUrl: 'https://ohi-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: 'OHI14647',
    trOhid2025: 'OHI15566',
    CRH_2025_OHI_IDS: ['OHI15415'],
    Bradesco2025: ['OHI15569'],
};

const prodEuConfig = {
    apiBasePath: 'https://eu-ohi-analytics.orglabsolutions.com/api/v1',
    pptBasePath: 'https://solutions.mckinsey.com/ppservice/api',
    clientId: '507706d1-32f9-440b-88cd-5cbcc99a9cb0',
    redirectBaseUrl: 'https://eu-ohi-analytics.orglabsolutions.com',
    oidcConfigUrl: 'https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
    textAnalyticsUrl: 'https://solutions.mckinsey.com/textanalytics/',
    gsodBaseUrl: 'https://eu-ohi-analytics.orglabsolutions.com/gsod/api',
    trOhid2024: '',
    trOhid2025: '',
    CRH_2025_OHI_IDS: [],
    Bradesco2025: [],
};

function getAuthConfig() {
    if (typeof window === 'undefined') {
        return localConfig;
    }

    const { hostname } = window.location;

    if (hostname === LOCALHOST || hostname === '127.0.0.1') {
        return localConfig;
    }

    if (hostname === 'dev-analytics.orglabsolutions.com') {
        return devConfig;
    }

    if (hostname === 'stg-analytics.orglabsolutions.com') {
        return stgConfig;
    }

    if (hostname === 'us-ohi-analytics.orglabsolutions.com') {
        return prodUsConfig;
    }

    if (hostname === 'ohi-analytics.orglabsolutions.com') {
        return prodUkConfig;
    }

    if (hostname === 'eu-ohi-analytics.orglabsolutions.com') {
        return prodEuConfig;
    }

    return devConfig;
}

const AUTH0 = getAuthConfig();

export default AUTH0;
